import * as Icons from '@ant-design/icons';
import {
  Alert,
  Breadcrumb,
  Button,
  Card,
  Flex,
  Form,
  Table,
  Upload
} from 'antd';
import { CreateLayout } from 'components/layout/layout/CreateLayout';
import { Link } from 'react-router-dom';
import { PageHeader } from 'components/professor_area/PageHeader';
import { UserRow } from 'interfaces/bulk_users';
import { parseFile } from 'services/bulk-users';
import { useForm } from '@refinedev/antd';
import { useState } from 'react';

const FileTable = ({ userList }: { userList: UserRow[] }) => (
  <Table
    dataSource={userList}
    columns={[
      {
        title: 'Email',
        key: 'email',
        dataIndex: 'email'
      }
    ]}
    pagination={{ pageSize: 5 }}
  />
);

const checkField = (field: string) => field?.length && field.length > 0;

export const BulkUserSuspend = () => {
  const { formProps, saveButtonProps } = useForm({ redirect: false });

  const [userList, setUserList] = useState<UserRow[]>([]);

  const valid = userList.every(({ email }) => {
    return checkField(email);
  });

  // eslint-disable-next-line @typescript-eslint/ban-types
  const onFinish = (values: {}) => {
    formProps.onFinish!({ ...values, bulk: userList });
  };

  return (
    <CreateLayout
      breadcrumb={
        <Breadcrumb>
          <Breadcrumb.Item>
            <Flex gap={4}>
              <Icons.TeamOutlined />
              Alunos e docentes
            </Flex>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/students_teachers/users">Alunos</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>Suspender alunos em lote</Breadcrumb.Item>
        </Breadcrumb>
      }
      saveButtonProps={{
        ...saveButtonProps,
        disabled: !valid || userList.length === 0
      }}
    >
      <PageHeader title="Suspender alunos em lote" icon={Icons.TeamOutlined} />
      <Card>
        <Form {...formProps} layout="vertical" onFinish={onFinish}>
          <Form.Item>
            <Upload
              accept="text/csv"
              fileList={[]}
              onRemove={() => setUserList([])}
              beforeUpload={async newFile => {
                const rows = await parseFile(newFile);

                setUserList(rows);

                return false;
              }}
            >
              <Button icon={<Icons.UploadOutlined />}>Escolher arquivo</Button>
            </Upload>
          </Form.Item>
        </Form>
        <FileTable userList={userList} />
        {valid ? (
          <Alert type="warning" message="Usuários serão suspensos" />
        ) : (
          <Alert type="error" message="Arquivo inválido" />
        )}
      </Card>
    </CreateLayout>
  );
};
